import {
  FETCH_PRODUCT_PACKAGING_LIST,
  RESET_PRODUCT_PACKAGING_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const productPackagingListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_PACKAGING_LIST:
      return { list: action.payload, others: action.others };
    case RESET_PRODUCT_PACKAGING_LIST: {
      return initialState;
    }
    default:
      return state;
  }
};

export default productPackagingListReducer;
